import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import PublicNav from "../components/PublicNav";

const C = { green:"#006B3C", greenLt:"#E8F5EE", grayBd:"#E0E0E0", text:"#1A1A1A", textSub:"#666" };

const CLASS_INFO = {
  ECONOMIQUE: { label:"Économique", color:"#1565C0", bg:"#E3F2FD", icon:"🚃" },
  PREMIERE:   { label:"1ère Classe", color:"#6A1B9A", bg:"#F3E5F5", icon:"⭐" },
  VIP:        { label:"VIP",         color:"#E65100", bg:"#FFF3E0", icon:"👑" },
};

export default function Horaires() {
  const [trips, setTrips] = useState([]);

  useEffect(() => {
    api.get("/api/trips").then(r => setTrips(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ fontFamily:"'Segoe UI',sans-serif", minHeight:"100vh" }}>
      <PublicNav />

      <div style={{ background:`linear-gradient(135deg, #004D2B, #006B3C)`, padding:"40px 24px", textAlign:"center" }}>
        <h1 style={{ color:"#fff", fontSize:32, fontWeight:800, margin:0 }}>Horaires des trains</h1>
        <p style={{ color:"rgba(255,255,255,0.8)", marginTop:8 }}>Ligne Transgabonais - Tous les départs disponibles</p>
      </div>

      <div style={{ maxWidth:860, margin:"40px auto", padding:"0 16px" }}>
        {trips.length === 0 ? (
          <div style={{ textAlign:"center", padding:60, color:C.textSub }}>
            <div style={{ fontSize:48, marginBottom:12 }}>🚉</div>
            <p>Aucun horaire disponible pour le moment.</p>
          </div>
        ) : (
          <div style={{ background:"#fff", borderRadius:14, overflow:"hidden", border:`1px solid ${C.grayBd}` }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:C.greenLt }}>
                  {["Train","Départ","Destination","Heure départ","Heure arrivée","Classe","Prix","Places"].map(h => (
                    <th key={h} style={{ padding:"12px 14px", textAlign:"left", fontSize:12, fontWeight:700, color:C.textSub, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {trips.map((t,i) => {
                  const ci = CLASS_INFO[t.travelClass] || CLASS_INFO.ECONOMIQUE;
                  return (
                    <tr key={t.id} style={{ borderTop:`1px solid ${C.grayBd}`, background:i%2===0?"#fff":"#FAFAFA" }}>
                      <td style={s.td}><strong>{t.trainNumber}</strong></td>
                      <td style={s.td}>{t.departure}</td>
                      <td style={s.td}>{t.arrival}</td>
                      <td style={s.td}>{t.date} {t.departureTime}</td>
                      <td style={s.td}>{t.arrivalTime || "-"}</td>
                      <td style={s.td}>
                        <span style={{ background:ci.bg, color:ci.color, padding:"2px 8px", borderRadius:20, fontSize:11, fontWeight:600 }}>
                          {ci.icon} {ci.label}
                        </span>
                      </td>
                      <td style={s.td}><strong>{Number(t.price).toLocaleString("fr-FR")} FCFA</strong></td>
                      <td style={s.td}>{t.seats}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ background:C.greenLt, borderRadius:14, padding:20, marginTop:32, fontSize:13, color:C.textSub, textAlign:"center" }}>
          📌 Les horaires sont indicatifs et peuvent être sujets à modifications. Consultez les gares ou notre service client pour confirmation.
        </div>
      </div>
    </div>
  );
}

const s = { td: { padding:"12px 14px", fontSize:13 } };
